import { useQuery } from '@tanstack/react-query'
import { useCurrentNetwork } from '@mysten/dapp-kit-react'

import { useBackendClient } from '@/shared/kai/contexts/BackendClientContext'
import { GetVaultMetricsResponseType } from '@/shared/backend/types'

export const savMetricsQueryKey = (network: string) => ['sav-metrics', network] as const

export const useSAVMetrics = () => {
  const network = useCurrentNetwork()

  const backendClient = useBackendClient()

  const result = useQuery({
    queryKey: savMetricsQueryKey(network),
    queryFn: async () => {
      return await backendClient.getSavMetrics()
    },
    refetchInterval: 30 * 1000,
  })

  return {
    isLoading: result.isLoading,
    isError: result.isError,
    data: result.data as GetVaultMetricsResponseType,
  }
}
